// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Home_contentWrapper__gBggj","title":"Home_title__IfKZn","illustration":"Home_illustration__M6O1x"};